import { Action, createReducer, on } from '@ngrx/store';
import { attachMockEthernetGateway, attachMockEthernetGatewayToSites, isMockEthernetGatewaySite } from 'src/app/conf/mock-ethernet-gateway';
import { Site } from 'src/app/model/site';
import { TransferData } from 'src/app/model/transfer-data';

import * as SiteActions from './site.actions';

export interface State {
    sitesEmpty: boolean;
    sitesLoading: boolean;
    sites: Site[];
    currentSite?: Site;
    transfers: TransferData[];
    transferLoading: boolean;
    transferring: boolean;
    transferred: boolean;
    deleting: boolean;
    deleted: boolean;
    addEditSuccess: boolean;
    sitesOnlineDevices: Site[];
    sitesOnlineDevicesLoading: boolean;
}
export const initialState: State = {
    sitesEmpty: true,
    sitesLoading: false,
    sites: [],
    transfers: [],
    transferLoading: false,
    transferring: false,
    transferred: false,
    deleting: false,
    deleted: false,
    addEditSuccess: false,
    sitesOnlineDevices: [],
    sitesOnlineDevicesLoading: false,
};

const siteReducer = createReducer(
    initialState,
    on(SiteActions.getSiteSuccess, (state, payload) => {
        const site = attachMockEthernetGateway(payload.site);
        return {
            ...state,
            currentSite: site,
            sites: [...state.sites.filter(s => s.Id !== site.Id), site]
        };
    }),
    on(SiteActions.getSites, (state) => ({ ...state, sitesLoading: true })),
    on(SiteActions.getSitesSuccess, (state, payload) => {
        const sites = attachMockEthernetGatewayToSites(payload.sites);
        return {
            ...state,
            sites,
            currentSite: sites.length > 0 ? sites[0] : undefined,
            sitesEmpty: sites.length === 0, sitesLoading: false
        };
    }),
    on(SiteActions.resetSites, (state) => ({ ...state, sites: [] })),
    on(SiteActions.getSitesOnlineDevices, (state) => ({
        ...state,
        sitesOnlineDevicesLoading: true,
    })),
    on(SiteActions.getSitesOnlineDevicesSuccess, (state, payload) => ({
        ...state,
        sitesOnlineDevices: payload.sites,
        sitesOnlineDevicesLoading: false,
    })),
    on(SiteActions.getSitesOnlineDevicesFailed, (state) => ({
        ...state,
        sitesOnlineDevices: [],
        sitesOnlineDevicesLoading: false,
    })),
    on(SiteActions.getSitesFailed, (state) => ({ ...state, sitesLoading: false })),
    on(SiteActions.setOwned, (state, payload) => {
        const own = (s: Site): Site => {
            if (isMockEthernetGatewaySite(s.Id)) {
                return {
                    ...s,
                    UserId: payload.currentUserId,
                    CurrentlyOwned: true,
                    Devices: (s.Devices || []).map(d => ({ ...d, OwnerId: payload.currentUserId })),
                };
            }
            return { ...s, CurrentlyOwned: s.UserId === payload.currentUserId };
        };
        return {
            ...state,
            sites: state.sites.map(own),
            currentSite: state.currentSite ? own(state.currentSite) : undefined,
        };
    }),
    on(SiteActions.addSite, (state) => ({ ...state, addEditSuccess: false })),
    on(SiteActions.addSiteSuccess, (state, payload) => ({
        ...state,
        addEditSuccess: true,
        sites: [payload.site, ...state.sites],
    })),
    on(SiteActions.updateSite, (state) => ({ ...state, addEditSuccess: false })),
    on(SiteActions.updateSiteSuccess, (state, payload) => {
        const siteIdx = state.sites.map((site) => site.Id).indexOf(payload.site.Id);
        const newSites = [
            ...state.sites.slice(0, siteIdx),
            payload.site,
            ...state.sites.slice(siteIdx + 1)
        ];
        return { ...state, sites: newSites, currentSite: payload.site, addEditSuccess: true, };
    }),
    on(SiteActions.deleteSiteCleanup, (state) => ({ ...state, deleted: false })),
    on(SiteActions.deleteSite, (state) => ({ ...state, deleting: true, deleted: false })),
    on(SiteActions.deleteSiteFailed, (state) => ({ ...state, deleting: false, deleted: false })),
    on(SiteActions.deleteSiteSuccess, (state, payload) => {
        const newSites = state.sites.filter((site) => site.Id !== payload.id);
        return {
            ...state,
            sites: newSites,
            sitesEmpty: state.sites.length === 0,
            deleting: false,
            deleted: true,
        };
    }),
    on(SiteActions.deleteSharedSite, (state) => ({ ...state, deleted: false })),
    on(SiteActions.deleteSharedSiteFailed, (state) => ({ ...state, deleted: false })),
    on(SiteActions.deleteSharedSiteSuccess, (state, payload) => {
        const newSites = state.sites.filter((site) => site.Id !== payload.id);
        return {
            ...state,
            sites: newSites,
            sitesEmpty: state.sites.length === 0,
            deleted: true,
        };
    }),
    /*on(SiteActions.setCurrentSite, (state, payload) => {
        let currentSite;
        if (state.sites.length === 0) {
            return { ...state };
        }
        const findSite = state.sites.find(site => site.Id === payload.siteId);
        if (typeof payload.siteId !== 'undefined' && findSite !== undefined && findSite !== null) {
            localStorage.setItem(LOCALSTORAGE_CURRENT_SITE_ID, payload.siteId.toString());
            currentSite = findSite;
        } else {
            currentSite = state.sites[0];
        }
        return { ...state, currentSite };
    }),*/
    on(SiteActions.setCurrentSiteSuccess, (state, payload) => {
        return { ...state, currentSite: attachMockEthernetGateway(payload.site) };
    }),

    on(SiteActions.resetCurrentSite, (state) => {
        return { ...state, currentSite: undefined };
    }),
    on(SiteActions.assignTechnicianSuccess, (state, payload) => {
        const updatedSite = state.sites.find((s) => s.Id === payload.siteId);
        if (!updatedSite) {
            return state;
        }
        return {
            ...state,
            sites: [
                ...state.sites.filter(s => s.Id !== payload.siteId),
                { ...updatedSite, TechnicianId: payload.technicianId },
            ]
        };
    }),
    on(SiteActions.unassignTechnicianSuccess, (state, payload) => {
        const updatedSite = state.sites.find((s) => s.Id === payload.siteId);
        if (!updatedSite) {
            return state;
        }
        return {
            ...state,
            sites: [
                ...state.sites.filter(s => s.Id !== payload.siteId),
                { ...updatedSite, TechnicianId: null },
            ]
        };
    }),
    on(SiteActions.getSiteTransfers, (state) => ({ ...state, tranferLoading: true })),
    on(SiteActions.getSiteTransfersSuccess, (state, payload) => ({
        ...state,
        transfers: payload.siteTransfers,
        transferLoading: false,
    })),
    on(SiteActions.getSiteTransfersFailed, (state) => ({ ...state, transferLoading: false })),
    on(SiteActions.resetTransferSite, (state) => ({ ...state, transferring: false, transferred: false })),
    on(SiteActions.transferSite, (state) => ({ ...state, transferring: true, transferred: false })),
    on(SiteActions.transferSiteSuccess, (state) => ({ ...state, transferring: false, transferred: true })),
    on(SiteActions.transferSiteFailed, (state) => ({ ...state, transferring: false, transferred: false })),
    on(SiteActions.deleteSiteTransferSuccess, (state, payload) => ({
        ...state,
        transfers: state.transfers.filter(tr => tr.Id !== payload.transferId),
    })),
    // on(SiteActions.getThermoDeviceSuccess, (state, payload) => ({
    //     ...state,
    //     deviceThermo: payload.deviceThermo,
    // })),
    on(SiteActions.resetAddEditSiteForm, (state) => ({
        ...state, addEditSuccess: false,
    })),
);

export const reducer = (state: State | undefined, action: Action): State => siteReducer(state, action);
